import { render, staticRenderFns } from "./CreatorsLine.vue?vue&type=template&id=5920bb9c"
import script from "./CreatorsLine.vue?vue&type=script&lang=js"
export * from "./CreatorsLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports